// type CustomerMembershipEvent = {
//     id: number
//     customer_membership: number;
//     membership_event: {
//         id: number
//         description: string
//     },
//     membership_event_reason: {

import { useMemo } from 'react';

//     }
// }

export const useLatestMembershipEvent = events => {
  const largestIdEvent = useMemo(() => {
    let largestIdEvent = undefined;
    events?.forEach(e => {
      if (e.id > (largestIdEvent?.id || 0)) {
        largestIdEvent = e;
      }
    });
    return largestIdEvent;
  }, [events]);

  return largestIdEvent;
};
